import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import lodashIsEmpty from 'lodash/isEmpty';

import StoreCard from '../../../Components/Card/Store';
import ItemSmall from '../../../Components/Card/ItemSmall';
import HorizontalListing, {
  getMarginStyle,
} from '../../../Components/HorizontalListing';
import modals from '../../../Components/Sheets/modals';
import AnalyticsHelper from '../../../Helper/Analytics';
import ThemeStyle from '../../../Theme/styles';

const HomeSearchedItem = ({ searched_items, onItemPress, ...rest }) => {
  const hasItemResult = !lodashIsEmpty(searched_items);

  const _onStoreItemResultPressed = (storeItem) => {
    AnalyticsHelper.itemSelection({
      ...storeItem,
      fromSection: 'Search result',
    });
    modals.show(modals.PRODUCT, { id: storeItem.id });
  };

  const _renderItem = ({ isFirstOfList, isLastOfList, item }) => (
    <View style={getMarginStyle(isFirstOfList, isLastOfList, false)}>
      <ItemSmall {...item} onPress={() => _onStoreItemResultPressed(item)} />
    </View>
  );

  return (
    <Fragment>
      <View
        style={[
          ThemeStyle.pageHorizontalSpacing,
          ThemeStyle.spacingBottomMedium,
        ]}
      >
        <StoreCard {...rest} fullWidthOnMobile />
      </View>
      {hasItemResult && (
        <View style={ThemeStyle.spacingBottomMedium}>
          <HorizontalListing data={searched_items} renderItem={_renderItem} />
        </View>
      )}
    </Fragment>
  );
};

HomeSearchedItem.propTypes = {
  searched_items: PropTypes.array,
  onItemPress: PropTypes.func.isRequired,
};

export default HomeSearchedItem;
